// Brand palette lifted from the company site (/hebe): gold #C9A86C + charcoal #1A1A1A + warm
// neutrals (eco-luxury). Used for the FO CHROME only (top bar, primary actions, accents, links).
// Semantic room-status colors (status.jsx) stay traffic-light and are deliberately NOT rebranded.
export const theme = {
  gold: "#c9a86c",
  goldDark: "#8c6d3f", // accessible gold for text/links on white (WCAG-safe)
  goldSoft: "#f5eee0",
  ink: "#1a1a1a", // charcoal (dark nav / primary-on-gold text)
  inkSoft: "#3a3a3a",
  surface: "#ffffff",
  canvas: "#f7f5f1", // warm off-white app background
  border: "#e7e2d8", // warm neutral border
  muted: "#78725f", // warm muted text (darkened to ~4.8:1 on white — WCAG AA)
  ink900: "#1a1a1a",
  ink700: "#44413a",
  // The error pair every dialog in the kit had been hard-coding. Named here so a rejection is
  // impossible to render as a neutral grey hint by accident.
  danger: "#b42318",
  dangerBg: "#fdecea",
  dangerBorder: "#f7cfca",
};
